/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveRequest } from '../models/ApproveRequest';
import type { Body_upload_onboarding_photo_by_token_endpoint_api_v1_employee_onboarding_invites_by_token__invite_token__photos_post } from '../models/Body_upload_onboarding_photo_by_token_endpoint_api_v1_employee_onboarding_invites_by_token__invite_token__photos_post';
import type { CandidatePiiRevealRequest } from '../models/CandidatePiiRevealRequest';
import type { CreateInviteRequest } from '../models/CreateInviteRequest';
import type { OnboardingBindCurrentWechatRequest } from '../models/OnboardingBindCurrentWechatRequest';
import type { RejectRequest } from '../models/RejectRequest';
import type { ResendInviteRequest } from '../models/ResendInviteRequest';
import type { RevokeRequest } from '../models/RevokeRequest';
import type { SalaryStandardCreate } from '../models/SalaryStandardCreate';
import type { SalaryStandardUpdate } from '../models/SalaryStandardUpdate';
import type { SelfFillRequest } from '../models/SelfFillRequest';
import type { SuccessResponse_ApproveResponse_ } from '../models/SuccessResponse_ApproveResponse_';
import type { SuccessResponse_CandidatePiiRevealResponse_ } from '../models/SuccessResponse_CandidatePiiRevealResponse_';
import type { SuccessResponse_CreateInviteResponse_ } from '../models/SuccessResponse_CreateInviteResponse_';
import type { SuccessResponse_DictionaryResponse_ } from '../models/SuccessResponse_DictionaryResponse_';
import type { SuccessResponse_InviteDetailResponse_ } from '../models/SuccessResponse_InviteDetailResponse_';
import type { SuccessResponse_InviteListResponse_ } from '../models/SuccessResponse_InviteListResponse_';
import type { SuccessResponse_InvitePublicPreviewResponse_ } from '../models/SuccessResponse_InvitePublicPreviewResponse_';
import type { SuccessResponse_OnboardingBindCurrentWechatResponse_ } from '../models/SuccessResponse_OnboardingBindCurrentWechatResponse_';
import type { SuccessResponse_OnboardingPhotoUploadResponse_ } from '../models/SuccessResponse_OnboardingPhotoUploadResponse_';
import type { SuccessResponse_RejectResponse_ } from '../models/SuccessResponse_RejectResponse_';
import type { SuccessResponse_RevokeResponse_ } from '../models/SuccessResponse_RevokeResponse_';
import type { SuccessResponse_SalaryStandardItem_ } from '../models/SuccessResponse_SalaryStandardItem_';
import type { SuccessResponse_SalaryStandardListResponse_ } from '../models/SuccessResponse_SalaryStandardListResponse_';
import type { SuccessResponse_SelfFillResponse_ } from '../models/SuccessResponse_SelfFillResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeeOnboardingService {
    /**
     * Create Invite Endpoint
     * v0.12.1 汇报线发起员工入职邀请 (4 角色 base + service 层归属校验).
     * @returns SuccessResponse_CreateInviteResponse_ Successful Response
     * @throws ApiError
     */
    public static createInviteEndpointApiV1EmployeeOnboardingInvitesPost({
        requestBody,
    }: {
        requestBody: (CreateInviteRequest | ResendInviteRequest),
    }): CancelablePromise<SuccessResponse_CreateInviteResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Invites Endpoint
     * v0.12.1: 列表 (4 角色 base + service 层可见集派生).
     *
     * - super_admin / owner: 全店全 state
     * - area_manager: 自绑定店所有 state (area_store_assignment)
     * - store_manager: 自店所有 state
     * @returns SuccessResponse_InviteListResponse_ Successful Response
     * @throws ApiError
     */
    public static listInvitesEndpointApiV1EmployeeOnboardingInvitesGet({
        state,
        storeId,
        limit = 50,
        offset,
    }: {
        /**
         * 按派生状态过滤 (v0.12.2 反序 9 态)
         */
        state?: ('draft' | 'area_reviewing' | 'owner_reviewing' | 'invite_sent' | 'self_filling' | 'completed' | 'returned' | 'rejected' | 'revoked' | 'expired' | null),
        storeId?: (number | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<SuccessResponse_InviteListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-onboarding/invites',
            query: {
                'state': state,
                'store_id': storeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Returned Invite Endpoint
     * VERSION-D #62: 区域/老板退回后, 发起店长修正入职邀请内容.
     * @returns SuccessResponse_CreateInviteResponse_ Successful Response
     * @throws ApiError
     */
    public static updateReturnedInviteEndpointApiV1EmployeeOnboardingInvitesInviteIdPatch({
        inviteId,
        requestBody,
    }: {
        inviteId: number,
        requestBody: CreateInviteRequest,
    }): CancelablePromise<SuccessResponse_CreateInviteResponse_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/employee-onboarding/invites/{invite_id}',
            path: {
                'invite_id': inviteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Detail Invite Endpoint
     * v0.12.1: 详情 + PII 解密 (4 角色 base + service 层 actor_can_see_store 归属校验).
     *
     * 任何能看见 invite 的角色都能解密 PII (业务对齐, 含店长发起人自查需求, spec §3.4).
     * @returns SuccessResponse_InviteDetailResponse_ Successful Response
     * @throws ApiError
     */
    public static detailInviteEndpointApiV1EmployeeOnboardingInvitesInviteIdGet({
        inviteId,
    }: {
        inviteId: number,
    }): CancelablePromise<SuccessResponse_InviteDetailResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-onboarding/invites/{invite_id}',
            path: {
                'invite_id': inviteId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reveal Candidate Pii Endpoint
     * POST /employee-onboarding/invites/{id}/pii/reveal — 显式取候选人完整证件号, **每次落审计**。
     *
     * 详情 GET 只回 last4 / 存在位。完整号必须点名字段来要 —— 这样"谁在什么时候看了谁的哪个
     * 证件号"才是可回答的问题。(此前明文随详情自动下发, 前端的「点击查看完整」只是本地展开,
     * "点击会被记录"是假的。)
     *
     * 鉴权**没有放宽**: 与详情同一条链 (CHAIN_ROLES + service 层跨店 guard)。
     * 审计**先于**返回 (fail-closed): 审计写不进去就不给明文。
     * @returns SuccessResponse_CandidatePiiRevealResponse_ Successful Response
     * @throws ApiError
     */
    public static revealCandidatePiiEndpointApiV1EmployeeOnboardingInvitesInviteIdPiiRevealPost({
        inviteId,
        requestBody,
    }: {
        inviteId: number,
        requestBody: CandidatePiiRevealRequest,
    }): CancelablePromise<SuccessResponse_CandidatePiiRevealResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/{invite_id}/pii/reveal',
            path: {
                'invite_id': inviteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Invite Wxacode Endpoint
     * A1 真实可达通道: 招聘邀请自填页小程序码图片 (HR/上级生成给候选扫码).
     *
     * 复用 Ember 微信服务端能力 (stable_token → getwxacode), scoping 与 detail 同口径
     * (system 读 + actor_can_see_store), 仅 invite_sent/self_filling 暴露.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static inviteWxacodeEndpointApiV1EmployeeOnboardingInvitesInviteIdWxacodeGet({
        inviteId,
    }: {
        inviteId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-onboarding/invites/{invite_id}/wxacode',
            path: {
                'invite_id': inviteId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Invite Endpoint
     * v0.12.1 撤销 (发起人本人 + 上级 area_manager/owner/super_admin; service 派生).
     *
     * 其他 store_manager (非发起人本人) → 403.
     * @returns SuccessResponse_RevokeResponse_ Successful Response
     * @throws ApiError
     */
    public static revokeInviteEndpointApiV1EmployeeOnboardingInvitesInviteIdRevokePost({
        inviteId,
        requestBody,
    }: {
        inviteId: number,
        requestBody: RevokeRequest,
    }): CancelablePromise<SuccessResponse_RevokeResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/{invite_id}/revoke',
            path: {
                'invite_id': inviteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Public View By Token Endpoint
     * 候选人扫码预览 (公开, 不依赖 JWT, 脱敏).
     *
     * IP 限流: 1 个 IP 每分钟 60 次 view (防 token 枚举攻击).
     * @returns SuccessResponse_InvitePublicPreviewResponse_ Successful Response
     * @throws ApiError
     */
    public static publicViewByTokenEndpointApiV1EmployeeOnboardingInvitesByTokenInviteTokenGet({
        inviteToken,
    }: {
        inviteToken: string,
    }): CancelablePromise<SuccessResponse_InvitePublicPreviewResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-onboarding/invites/by-token/{invite_token}',
            path: {
                'invite_token': inviteToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Onboarding Photo By Token Endpoint
     * 候选人匿名上传入职证件影像 (token 即凭证)。
     *
     * 只在 invite_sent / self_filling 态可用; magic bytes 校验真实图片类型。
     * @returns SuccessResponse_OnboardingPhotoUploadResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadOnboardingPhotoByTokenEndpointApiV1EmployeeOnboardingInvitesByTokenInviteTokenPhotosPost({
        inviteToken,
        formData,
    }: {
        inviteToken: string,
        formData: Body_upload_onboarding_photo_by_token_endpoint_api_v1_employee_onboarding_invites_by_token__invite_token__photos_post,
    }): CancelablePromise<SuccessResponse_OnboardingPhotoUploadResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/by-token/{invite_token}/photos',
            path: {
                'invite_token': inviteToken,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Self Fill Endpoint
     * 候选人提交自填 PII (公开, token 即凭证).
     *
     * IP 限流: 1 个 IP 每分钟 10 次 self-fill (防爆破).
     * @returns SuccessResponse_SelfFillResponse_ Successful Response
     * @throws ApiError
     */
    public static selfFillEndpointApiV1EmployeeOnboardingInvitesByTokenInviteTokenSelfFillPost({
        inviteToken,
        requestBody,
    }: {
        inviteToken: string,
        requestBody: SelfFillRequest,
    }): CancelablePromise<SuccessResponse_SelfFillResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/by-token/{invite_token}/self-fill',
            path: {
                'invite_token': inviteToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bind Current Wechat By Token Endpoint
     * 候选入职完成后, 用当前微信绑定员工并直接登录。
     * @returns SuccessResponse_OnboardingBindCurrentWechatResponse_ Successful Response
     * @throws ApiError
     */
    public static bindCurrentWechatByTokenEndpointApiV1EmployeeOnboardingInvitesByTokenInviteTokenBindCurrentWechatPost({
        inviteToken,
        requestBody,
    }: {
        inviteToken: string,
        requestBody: OnboardingBindCurrentWechatRequest,
    }): CancelablePromise<SuccessResponse_OnboardingBindCurrentWechatResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/by-token/{invite_token}/bind-current-wechat',
            path: {
                'invite_token': inviteToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Approve Invite Endpoint
     * v0.12.1 汇报线复核 approve (派生两段).
     *
     * service 层派生:
     * - state=area_reviewing + actor area_manager (绑定该 store) → owner_reviewing
     * - state=owner_reviewing + actor owner → approved + 激活 dim_employee
     * - super_admin god-mode 旁路 (DEC-0019)
     * - 防自批: invite.issued_by_employee_id == actor.employee_id → 403 SELF_APPROVE_FORBIDDEN
     * @returns SuccessResponse_ApproveResponse_ Successful Response
     * @throws ApiError
     */
    public static approveInviteEndpointApiV1EmployeeOnboardingInvitesInviteIdApprovePost({
        inviteId,
        requestBody,
    }: {
        inviteId: number,
        requestBody: ApproveRequest,
    }): CancelablePromise<SuccessResponse_ApproveResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/{invite_id}/approve',
            path: {
                'invite_id': inviteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reject Invite Endpoint
     * v0.12.1 汇报线 reject (任一复核段都可拒 → 终态 rejected).
     *
     * service 层 RBAC 派生 (同 approve, 不防自批 — spec §5).
     * @returns SuccessResponse_RejectResponse_ Successful Response
     * @throws ApiError
     */
    public static rejectInviteEndpointApiV1EmployeeOnboardingInvitesInviteIdRejectPost({
        inviteId,
        requestBody,
    }: {
        inviteId: number,
        requestBody: RejectRequest,
    }): CancelablePromise<SuccessResponse_RejectResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-onboarding/invites/{invite_id}/reject',
            path: {
                'invite_id': inviteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Salary Standards Endpoint
     * v0.12.3 GET list active — 全员可读 (任何已登录 actor).
     * @returns SuccessResponse_SalaryStandardListResponse_ Successful Response
     * @throws ApiError
     */
    public static listSalaryStandardsEndpointApiV1SalaryStandardsGet({
        position,
        cityCode,
        activeOnly = true,
    }: {
        /**
         * 按 position 过滤
         */
        position?: (string | null),
        /**
         * 按 city_code 过滤
         */
        cityCode?: (string | null),
        /**
         * true(默认)=仅当前生效 (effective_to IS NULL); false=含历史
         */
        activeOnly?: boolean,
    }): CancelablePromise<SuccessResponse_SalaryStandardListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/salary-standards',
            query: {
                'position': position,
                'city_code': cityCode,
                'active_only': activeOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Salary Standard Endpoint
     * v0.12.3 POST 新增薪酬标准 — finance + super_admin god-mode (DEC-0022).
     * @returns SuccessResponse_SalaryStandardItem_ Successful Response
     * @throws ApiError
     */
    public static createSalaryStandardEndpointApiV1SalaryStandardsPost({
        requestBody,
    }: {
        requestBody: SalaryStandardCreate,
    }): CancelablePromise<SuccessResponse_SalaryStandardItem_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/salary-standards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Salary Standard Endpoint
     * v0.12.3 PATCH 修改薪酬标准 (乐观锁强制) — finance + super_admin god-mode (DEC-0022).
     * @returns SuccessResponse_SalaryStandardItem_ Successful Response
     * @throws ApiError
     */
    public static updateSalaryStandardEndpointApiV1SalaryStandardsStandardIdPatch({
        standardId,
        requestBody,
    }: {
        standardId: number,
        requestBody: SalaryStandardUpdate,
    }): CancelablePromise<SuccessResponse_SalaryStandardItem_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/salary-standards/{standard_id}',
            path: {
                'standard_id': standardId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Dictionary Endpoint
     * 字典查询. 任何已登录 actor 可读.
     * @returns SuccessResponse_DictionaryResponse_ Successful Response
     * @throws ApiError
     */
    public static dictionaryEndpointApiV1DictionariesKindGet({
        kind,
        position,
        cityCode,
        storeId,
        prefix,
    }: {
        kind: 'cities' | 'position-levels' | 'salary-standards',
        /**
         * position-levels/salary-standards 过滤
         */
        position?: (string | null),
        /**
         * salary-standards 过滤
         */
        cityCode?: (string | null),
        /**
         * 按有权访问门店过滤当前可用薪资标准
         */
        storeId?: (number | null),
        /**
         * cities 前缀匹配
         */
        prefix?: (string | null),
    }): CancelablePromise<SuccessResponse_DictionaryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/{kind}',
            path: {
                'kind': kind,
            },
            query: {
                'position': position,
                'city_code': cityCode,
                'store_id': storeId,
                'prefix': prefix,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
